'use strict';

/**
 *
 * @name: nownessApp.analytics
 *
 */

import angularticsGtmNownessModule from './angulartics-gtm-nowness.module';
import analyticsRun from './nn-analytics.run';
import angularticsService from './nn-angulartics.service';
import campaignTrackingFactory from './nn-campaign-tracking.factory';

const AnalyticsModule = angular
  .module('nownessApp.analytics', [
    'angulartics',
    angularticsGtmNownessModule
  ])
  .run(analyticsRun)
  .factory('angularticsService', angularticsService)
  .factory('campaignTrackingServ', campaignTrackingFactory);

export default AnalyticsModule.name;



// WEBPACK FOOTER //
// ./app/components/nn-analytics/nn-analytics.module.js